import EVENTS from "./events";

export default function sendEvent(event, options) {
  const evt = EVENTS.find(function (e) {
    return e.key == event;
  });
  if (options) {
    evt.options = options;
  }
  const eventToDispatch = new CustomEvent("SDK_EVENT", { detail: evt });
  document.dispatchEvent(eventToDispatch);
}
